export default "__VITE_ASSET__DN3se_uq__$_?nuxt_component=async&nuxt_component_name=SvgoPartnerItsumo&nuxt_component_export=default__"